var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarbados(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_7794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2174 1.19072C15.6397 0.427875 13.8698 0 12 0C10.1302 0 8.36025 0.427875 6.78262 1.19072L5.73914 12L6.78262 22.8093C8.36025 23.5721 10.1302 24 12 24C13.8698 24 15.6397 23.5721 17.2174 22.8093L18.2609 12L17.2174 1.19072Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.78263 1.19114C2.76872 3.13205 0 7.24247 0 12C0 16.7575 2.76872 20.868 6.78263 22.8089V1.19114Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2174 1.19114V22.8089C21.2313 20.868 24 16.7575 24 12C24 7.24251 21.2313 3.13205 17.2174 1.19114Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6522 7.30434L16.3522 7.65431L15.6522 7.30434L14.9522 6.95437C14.91 7.03879 13.996 8.89847 13.8467 11.7391H12.7826V7.30434L12 6.26086L11.2174 7.30434V11.7391H10.1534C10.004 8.89847 9.09006 7.03879 9.04783 6.95437L7.64786 7.65436C7.65751 7.67358 8.60875 9.60975 8.60875 12.5218V13.3044H11.2174V17.7392H12.7826V13.3044H15.3913V12.5217C15.3913 11.0162 15.6518 9.77475 15.8704 8.9984C16.1087 8.15184 16.3507 7.65745 16.3531 7.65253L15.6522 7.30434Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_7794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarbados);
export default __webpack_public_path__ + "static/media/barbados.67b3c790d18898b36e5412c68f13c0f7.svg";
export { ForwardRef as ReactComponent };